const modalGallery = () => {
    const galleryButtons = document.querySelectorAll('.post-gallery__btn');
    if (galleryButtons.length === 0) return;

    const galleryModalEl = document.getElementById('galleryModal');
    if (!galleryModalEl) return;

    const modalBody = galleryModalEl.querySelector('.modal-body');
    const buttons = Array.from(galleryButtons);

    // Costruisce le slide con tutte le immagini della gallery
    const slides = buttons.map(btn => {
        const imageUrl = btn.getAttribute('data-url');
        const imageAlt = btn.getAttribute('data-alt') || '';
        return `<div class="swiper-slide"><img src="${imageUrl}" alt="${imageAlt}" class="gallery__modal__img"></div>`;
    }).join('');

    modalBody.innerHTML = `
        <div class="gallery__modal__slider swiper">
            <div class="swiper-wrapper">${slides}</div>
            <div class="d-flex justify-content-center align-items-center gap-3 mt-3">
                <div class="swiper-button-prev"></div>
                <div class="swiper-pagination"></div>
                <div class="swiper-button-next"></div>
            </div>
        </div>`;

    const sliderEl = modalBody.querySelector('.swiper');
    let swiperInstance = null;
    let startIndex = 0;

    // Istanza Modal Bootstrap
    const galleryModal = new Modal(galleryModalEl, {
        keyboard: true,
        backdrop: true
    });

    buttons.forEach((btn, index) => {
        btn.addEventListener('click', () => {
            startIndex = index;
            galleryModal.show();
        });
    });

    // Nasconde lo slider prima dell'apertura per evitare il flash
    // sulla prima immagine mentre swiper si posiziona sull'indice corretto
    galleryModalEl.addEventListener('show.bs.modal', () => {
        sliderEl.classList.remove('is-ready');
        if (swiperInstance) {
            swiperInstance.slideTo(startIndex, 0);
        }
    });

    // Inizializza/aggiorna lo swiper quando il modal è completamente visibile
    // (le dimensioni sono corrette solo dopo l'apertura)
    galleryModalEl.addEventListener('shown.bs.modal', () => {
        if (swiperInstance) {
            swiperInstance.update();
        } else {
            swiperInstance = new Swiper(sliderEl, {
                slidesPerView: 1,
                spaceBetween: 20,
                initialSlide: startIndex,
                pagination: {
                    el: sliderEl.querySelector('.swiper-pagination'),
                    clickable: true,
                },
                navigation: {
                    nextEl: sliderEl.querySelector('.swiper-button-next'),
                    prevEl: sliderEl.querySelector('.swiper-button-prev'),
                },
            });
        }

        // Mostra lo slider solo dopo che è posizionato sull'indice corretto
        requestAnimationFrame(() => sliderEl.classList.add('is-ready'));
    });
};

export default modalGallery;
